import React, { useState } from 'react';
import { toast } from 'react-toastify';
import OpportunityInfoTab from './OpportunityInfoTab';
import DocumentsTab from '../opportunity-documents/DocumentsTab.jsx';

const OpportunityDetails = ({oppData}) =>{
    const [activeTab, setActiveTab] = useState(0);
    
    let tabs =  ["Qualification", "Information Gathering", "Documents", "Conversion"];

    if (oppData.funnel === 'Re-KYC'){
        tabs = ["Qualification", "Documents"];
    }
    return(
        <div className="w-full flex justify-between items-center mx-2 md:ml-2 md:mr-0">
            <div className="p-3 md:p-4 rounded-2xl md:rounded-3xl w-full mr-0 md:mr-2">
                <div className="flex space-x-4 md:space-x-6 ml-2 md:ml-3 overflow-x-auto scrollbar-hide">
                    {tabs.map((tab, index) => (
                        <button
                            key={index}
                            onClick={() => {
                                setActiveTab(index);
                            }}
                            className={`relative text-sm md:text-md font-medium pb-1 transition-all mb-3 whitespace-nowrap flex-shrink-0 ${
                                activeTab === index ? "text-black border-b-4 px-2 border-yellow-300" : "text-gray-500"
                            }`}
                        >
                            {tab}
                        </button>
                    ))}
                </div>
                {activeTab === 0 && (
                    <div className="w-full bg-white p-4 md:p-7 rounded-2xl md:rounded-3xl shadow-lg">
                        <div className="flex flex-col md:flex-row md:justify-between md:items-start gap-3 md:gap-0">
                            <div className="flex items-center">
                                <p className="font-bold text-lg md:text-2xl text-[#1E293B]">Qualification</p>
                            </div>
                        </div>
                        <div className="flex flex-col md:flex-row md:items-center mt-3 md:mt-5">
                            <span className="border-b border-gray-200 pb-2 w-full flex flex-col md:flex-row gap-1 md:gap-0">
                                <span className="w-full md:w-1/5 font-bold text-[#475569]">MM Account ID</span>
                                <span className="w-full md:flex-1 text-[#475569]">{oppData.mm_acc_id}</span>
                                <button
                                    onClick={() => {
                                        navigator.clipboard.writeText(oppData.mm_acc_id);
                                        toast.success('Copied to clipboard!');
                                    }}
                                    className="ml-2 bg-white text-blue-600 rounded focus:outline-none focus:ring-2 focus:ring-blue-500"
                                    >
                                        <img src="/icons/content_copy.svg" className='size-6'/>
                                </button>
                            </span>
                        </div>
                        <div className="flex flex-col md:flex-row md:items-center mt-3 md:mt-5">
                            <span className="border-b border-gray-200 pb-2 w-full flex flex-col md:flex-row gap-1 md:gap-0">
                                <span className="w-full md:w-1/5 font-bold text-[#475569]">Opportunity Remark</span>
                                <span className="w-full md:flex-1 text-[#475569]">{oppData.opp_name}</span>
                                <button
                                    onClick={() => {
                                        navigator.clipboard.writeText(oppData.opp_name);
                                        toast.success('Copied to clipboard!');
                                    }}
                                    className="ml-2 bg-white text-blue-600 rounded focus:outline-none focus:ring-2 focus:ring-blue-500"
                                    >
                                        <img src="/icons/content_copy.svg" className='size-6'/>
                                </button>
                            </span>
                        </div>
                        <div className="flex flex-col md:flex-row md:items-center mt-3 md:mt-5">
                            <span className="border-b border-gray-200 pb-2 w-full flex flex-col md:flex-row gap-1 md:gap-0">
                                <span className="w-full md:w-1/5 font-bold text-[#475569]">Account Name</span>
                                <span className="w-full md:flex-1 text-[#475569]">{oppData.name}</span>
                                <button
                                    onClick={() => {
                                        navigator.clipboard.writeText(oppData.name);
                                        toast.success('Copied to clipboard!');
                                    }}
                                    className="ml-2 bg-white text-blue-600 rounded focus:outline-none focus:ring-2 focus:ring-blue-500"
                                >
                                    <img src="/icons/content_copy.svg" className='size-6'/>
                                </button>
                            </span>
                        </div>
                        {(oppData.funnel === 'Insurance') && (
                            <div className="flex items-center mt-5">
                                <span className="border-b border-gray-200 pb-2 w-full flex">
                                    <span className="w-1/5 font-bold text-[#475569]">Ref ID</span>
                                    <span className="w-full md:flex-1 text-[#475569]">{oppData?.ref_id || "N/A"}</span>
                                    <button
                                        onClick={() => {
                                            navigator.clipboard.writeText(oppData?.name);
                                            toast.success('Copied to clipboard!');
                                        }}
                                        className="ml-2 bg-white text-blue-600 rounded focus:outline-none focus:ring-2 focus:ring-blue-500"
                                    >
                                        <img src="/icons/content_copy.svg" className='size-6'/>
                                    </button>
                                </span>
                            </div>
                        )}
                    </div>
                )}
                {activeTab === 1 && (
                    oppData.funnel === 'Re-KYC' ? (
                        <DocumentsTab oppData={oppData} />
                    ) : (
                        <OpportunityInfoTab oppData={oppData} />
                    )
                )}
                {activeTab === 2 && (
                    <DocumentsTab leadID={oppData.lead_id} funnel = {oppData.funnel}/>
                )}
                {activeTab === 3 && (
                    <div>
                        Conversion Tab Content
                    </div>
                )}
            </div>
        </div>
    )
};
export default OpportunityDetails;